import React, { useState } from "react";

import { TbShieldCheck } from "react-icons/tb";
import styles from "./ProductFeatures.module.css";

interface ProductFeaturesProps {
  key_feature: string;
  description: string;
}

type TabKey = "key_feature" | "description";

const ProductFeatures: React.FC<ProductFeaturesProps> = ({
  key_feature,
  description,
}) => {
  const [activeTab, setActiveTab] = useState<TabKey>("key_feature");
  const keyFeatureHtml = typeof key_feature === "string" ? key_feature : "";

  const descriptionHtml = typeof description === "string" ? description : "";

  const hasKeyFeatures = keyFeatureHtml.trim().length > 0;
  const hasDescription = descriptionHtml.trim().length > 0;
  if (!hasKeyFeatures && !hasDescription) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.tabBar}>
        <div className={styles.tabs}>
          {hasKeyFeatures && (
            <button
              type="button"
              className={`${styles.tabBtn} ${
                activeTab === "key_feature" ? styles.tabActive : ""
              }`}
              onClick={() => setActiveTab("key_feature")}
            >
              Key Features
            </button>
          )}

          {hasDescription && (
            <button
              type="button"
              className={`${styles.tabBtn} ${
                activeTab === "description" ? styles.tabActive : ""
              }`}
              onClick={() => setActiveTab("description")}
            >
              Description
            </button>
          )}
        </div>
      </div>
      {/* <TbShieldCheck className={styles.shieldIcon} size={20} /> */}

      {activeTab === "key_feature" && hasKeyFeatures ? (
        <div
          className={styles.featureGrid}
          dangerouslySetInnerHTML={{
            __html: keyFeatureHtml,
          }}
        />
      ) : hasDescription ? (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{
            __html: descriptionHtml,
          }}
        />
      ) : null}
    </div>
  );
};

export default ProductFeatures;
